var _ellipse, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconEarn = function SvgIconEarn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12,
    cy: 9.545,
    fill: "currentColor",
    rx: 9,
    ry: 6.545
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3.247 16.302a.707.707 0 0 1 1.06.059c.693.837 1.752 1.601 3.123 2.153 1.367.55 2.945.85 4.57.85s3.203-.3 4.57-.85c1.371-.552 2.43-1.315 3.123-2.153a.707.707 0 0 1 1.06-.059c.307.303.331.82.054 1.156-.89 1.075-2.172 1.97-3.718 2.591-1.546.623-3.301.951-5.089.951s-3.543-.328-5.089-.95c-1.546-.623-2.827-1.517-3.718-2.593a.87.87 0 0 1 .054-1.155",
    clipRule: "evenodd"
  })));
};
export default SvgIconEarn;